module.exports = __webpack_public_path__ + "static/media/progress3.51f7b6ec.png";